import * as React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';

import { fetchLocations } from  './../redux/actions/locations'
import {Button, TYPES} from './../components/shared/button'
import AdminData from './../components/admin/adminData'
import AdminUserTable from './../components/admin/adminUserTable'
import Page from './../components/shared/page'
import './../styles/admin/admin.css'

class Admin extends React.Component {
  componentDidMount() {
    this.props.fetchLocations()
  }

  render () {
    return (
      <Page history={this.props.history} >
        <div className='admin-header'>
          <h3>ADMIN</h3>
          <div className="admin-header-buttons">
            <Link to={'/admin/test-scripts'}>
              <Button
                text='Test Scripts'
                type='admin'
                buttonType={TYPES.DEFAULT}
              />
            </Link>
            <Link to={'/admin/create-user'}>
              <Button
                text='Create User'
                type='admin'
                buttonType={TYPES.DEFAULT}/>
            </Link>
          </div>
        </div>
        <AdminData/>
        <AdminUserTable/>
      </Page>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = dispatch => {
  return {
    fetchLocations: () => {
      return dispatch(fetchLocations());
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Admin)



// WEBPACK FOOTER //
// ./src/pages/admin.js